import * as z from 'zod'
import { ApiModel } from './core'

const schema = z.object({})

export type LogAttributes = z.infer<typeof schema>

type SendMessageData = {
  driverId: UniqueId
  platform: string
  title: string
  message: string
}

function truncateText(text: string, maxLength = 256) {
  if (text.length <= maxLength) return text
  return text.slice(0, maxLength) + '...'
}

export class Log extends ApiModel<typeof schema, LogAttributes> {
  static jsonApiType = 'log'

  static schema = schema

  static async sendMessage(data: SendMessageData) {
    const url = `${Log.getJsonApiUrl()}/message`
    await Log.effectiveHttpClient.post(url, {
      ...data,
      message: truncateText(data.message),
    })
  }
}
